export default "__VITE_ASSET__rxxtpbCy__"